var replacementMap = {
  };

// Extract the first fragment from the URL path
var currentPath = window.location.pathname;
var fragments = currentPath.split("/");

// Since the URL starts with a '/', the first item in fragments will be empty, so the language sign will be the second item.
var langFragment = fragments[1];

// Check if the fragment is in the replacement map and replace it
if(replacementMap.hasOwnProperty(langFragment)) {
    var replacement = replacementMap[langFragment];
    if (replacement.length > 0) {
      fragments[1] = replacement;
    }
    else {
      fragments.splice(1,1);
    }
    var newPath = fragments.join("/");

    // Redirect to the new URL
    window.location.href = window.location.protocol + "//" + window.location.host + newPath + window.location.search + window.location.hash;
}

window.addEventListener('load', function() {
  var langSwitcherModal = document.getElementById("langSwitcher");

  // Get the button that opens the modal
  var langSwitchers = document.getElementsByClassName("lang-switcher-cta");
  
  // Get the <span> element that closes the modal
  var langSwitcherClose = document.getElementById("langSwitcherClose");
  
  // When the user clicks on the button, open the modal
  for(var i = 0; i < langSwitchers.length; i++) {
    langSwitchers[i].addEventListener('click', function(e) {
      langSwitcherModal.style.display = "block";
    });
  }
  
  // When the user clicks on <span> (x), close the modal
  langSwitcherClose.onclick = function() {
    langSwitcherModal.style.display = "none";
  }
  
  var langForm = document.getElementById('localization_form_language');
  var countryInput = langForm.querySelector('[name="country_code"]');
  var langInput = langForm.querySelector('[name="language_code"]');

  var langItems = document.getElementsByClassName('lang-switcher-item');
  for(var i = 0; i < langItems.length; i++) {
    langItems[i].addEventListener('click', function(e) {
      var target = e.target.closest('a'); 
      langInput.value = target.getAttribute('data-lang');
      countryInput.value = target.getAttribute('data-country');
      langForm.submit();
      return false;
    });
  }
});